import React from 'react';
import PropTypes from 'prop-types';
import styles from './ProductTag.module.css';

export default function ProductTag({ tagKey, children }) {
  return (
    <div
      className={styles.root}
      style={{ background: `var(--ui-tag-${tagKey}-bg)` }}>
      <span
        className={styles.label}
        style={{ color: `var(--ui-tag-${tagKey}-fg)` }}>
        {children}
      </span>
    </div>
  );
}

ProductTag.propTypes = {
  tagKey: PropTypes.oneOf(['sebraetec', 'consultoria', 'curso', 'solucao'])
    .isRequired,
  children: PropTypes.node.isRequired
};
